module.exports = __webpack_public_path__ + "media/images/50jahre-eb720d5347aecdc483630bbcfafb1b66.gif";